import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import FloatingContact from "../components/FloatingContact";
import FloatingNumber from "../components/landingcall/FloatingNumber";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import Sectors from "../components/landingsectors/Sectors";
import ExperienceSection from "../components/experiancesection/ExperienceSection";
import {FaUsers} from "react-icons/fa";


function HousekeepingManpowerService(){

    const services = [
        {
          name: "Housekeeping Manpower Services Gurugram",
          link: "/housekeeping-manpower-services-gurugram",
          icon: <FaUsers />
        },
        {
          name: "Housekeeping Manpower Services Ghaziabad",
          link: "/housekeeping-manpower-services-ghaziabad",
          icon: <FaUsers />
        },
        {
          name: "Housekeeping Manpower Services Noida",
          link: "/housekeeping-manpower-services-noida",
          icon: <FaUsers />
        },
         {
          name: "Housekeeping Manpower Services Delhi",
          link: "/housekeeping-manpower-services-delhi",
          icon: <FaUsers />
        }
      ];

    return(
        <Fragment>
          <Helmet>
            <title> House Keeping Services In Noida | Professional House Keeping Services </title>
            <meta name="tttle" content="House Keeping Services In Noida | Professional House Keeping Services" />
            <meta name="description" content="Looking for top-notch housekeeping services in Noida? Discover professional housekeeping services tailored to meet your needs." />
            <meta name="keywords" content=" Housekeeping services, Personal protection officer, Private security officer, Private security agents, Armed security services, Private Security Guard, Personal security guard, Private security personnel, Personal security officer, Private security service" />
            <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
          </Helmet>

            <FloatingNumber />
         
            <section id="about" className="about">
            <div class="container" data-aos="fade-up">

            <div className="section-header">
            <h2>Housekeeping Manpower Services</h2>
            <p>HelperJi: Expert Domestic Staffing Services </p>
             </div>

           <div className="row gy-4">
           <div className="col-lg-6">
            <img src="/assets/img/housekeeping1.png" className="img-fluid rounded-4 mb-4" alt="" />

            </div>
          
          <div className="col-lg-6">
            <div className="content ps-0 ps-lg-5">
              <h3 className="fst-italic">
              About Helperji
              </h3>
              <p> Helper Ji is one of the most trusted names in providing professional housekeeping manpower services for commercial, residential, and hospitality establishments. We specialize in maintaining a clean, organized, and hygienic environment through our skilled and experienced housekeeping staff. Whether it’s an office building, hospital, hotel, school, or apartment complex, our experts ensure that your surroundings remain spotless and well-maintained.</p>
              <p>In today’s fast-moving lifestyle, keeping up with daily cleaning and maintenance tasks can be difficult. That’s where Helper Ji comes in. Our dedicated housekeeping manpower services in Delhi, Noida, and Gurgaon are designed to take complete care of your cleaning requirements so you can focus on your core work. We offer end-to-end cleaning and maintenance solutions that not only enhance the look of your space but also promote a healthy and pleasant atmosphere.</p>
              <p>Housekeeping is more than just cleaning—it’s about ensuring comfort, hygiene, and safety. We understand that every space has unique needs, so we provide customized housekeeping manpower solutions that suit your environment and schedule. Over the years, Helper Ji has built a strong reputation for reliability, attention to detail, and service excellence.</p>
            <h3 className="fst-italic">
              Our Vision
              </h3>
              <p>At Helper Ji, our vision is to create and maintain cleaner, healthier, and more organized surroundings for everyone. We believe that a clean environment contributes to productivity and well-being. Our mission is to provide consistent, high-quality housekeeping manpower services that support our clients’ day-to-day operations. Whether it’s a home, office, hotel, or retail space, our professionals are trained to handle every task with dedication and care.</p>
            </div>
          </div>
        </div>

      </div>
    </section>

     <Sectors />

   <LandingPageClient />

   <ExperienceSection />

   <FloatingContact />

        <section className="py-5 sections-bg">
                         <div className="container">
                           <div className="row mb-4">
                             <div className="col text-center">
                               <h2 className="fw-bold">Our Locations</h2>
                               <p className="text-muted">
                                 Explore Our locations of Housekeeping Manpower
                                 Services
                               </p>
                             </div>
                           </div>
                   
                           <div className="row g-4">
                             {services.map((service, index) => (
                               <div className="col-md-3 col-sm-6" key={index}>
                                 <Link
                                   to={service.link}
                                   className="text-decoration-none text-dark"
                                 >
                                   <div className="card h-100 shadow-sm border-0 service-card">
                                     <div className="card-body d-flex align-items-center">
                                       <div className="service-icon me-3">
                                         {service.icon}
                                       </div>
                                       <h6 className="mb-0 fw-semibold">
                                         {service.name}
                                       </h6>
                                     </div>
                                   </div>
                                 </Link>
                               </div>
                             ))}
                           </div>
                         </div>
                       </section>
      
  </Fragment>

    )
}
export default HousekeepingManpowerService;